import * as React from "react";
import qs from "qs";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material/";

import { confirmCompleteLater } from "../../../../store/slices/learner";
import { useDispatch } from "../../../../store";

import RedirectDialog from "./RedirectDialog";
import Snackbar from "../../../ui-components/Snackbar";

export default function FinishLaterDialog({
	buttonStyle = {},
	title = "FINISH LATER"
}) {
	const [open, setOpen] = React.useState(false);
	const [showSnackbar, setShowSnackbar] = React.useState(false);
	const [isLoading, setIsLoading] = React.useState(false);
	const [completed, setCompleted] = React.useState(false);
	const [timer, setTimer] = React.useState(10);
	const publicUrl = process.env.PUBLIC_URL;

	const { invite } = qs.parse(window.location.search, {
		ignoreQueryPrefix: true,
	});
	const dispatch = useDispatch();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleConfirm = async () => {
		setIsLoading(true);
		const submit = await dispatch(confirmCompleteLater(invite));
		if (submit?.status === 200) {
			setCompleted(true);
			let countdown = 10;
			const t = setInterval(() => {
				setTimer(countdown - 1);
				if (countdown - 1 === 0) {
					clearInterval(t);
                    window.location.replace(`${publicUrl}/?quizId=acsf3`)
				}
				countdown--;
			}, 1000);
		} else {
			setShowSnackbar(true);
		}
		setIsLoading(false);
	};

	return (
		<React.Fragment>
			<Button
				variant="contained"
				sx={buttonStyle}
				color="error"
				onClick={handleClickOpen}
			>
				{title}
			</Button>
			<Dialog
				open={open && !completed}
				onClose={handleClose}
				aria-labelledby="finish-later-dialog"
				aria-describedby="finish-later-dialog-d"
			>
				<DialogTitle id="finish-later-dialog">
					Finish Later?
				</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{ fontWeight: "bold", mb: 2 }}>
						Are you sure you want to quit?
					</DialogContentText>
					<DialogContentText id="finish-later-dialog-d">
						We have saved your progress. You can come back later and
						finish the quiz.
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ justifyContent: "space-between" }}>
					<Button onClick={handleClose} disabled={isLoading}>
						Cancel
					</Button>
					<Button
						onClick={handleConfirm}
						autoFocus
						variant="contained"
						disabled={isLoading}
					>
						Yes
					</Button>
				</DialogActions>
			</Dialog>

			<RedirectDialog show={completed} timer={timer} />
			<Snackbar
				show={showSnackbar}
				onClose={() => setShowSnackbar(false)}
				message="Something went wrong while sending email."
			/>
		</React.Fragment>
	);
}
